import type { GlobalConfig } from "./DefaultGlobals";
import { DefaultGlobals } from "./DefaultGlobals";

const CAGlobals: GlobalConfig = {
  ...DefaultGlobals,
  country: "Canada",
};

export { CAGlobals };
